import clsx from "clsx";

import { type TableState } from "@features/sales-v4/types";
import { type SalesMetricV2 } from "@north-beam/nb-client-side/metrics-v2";
import { type SalesMetricRow } from "@north-beam/nb-common";
import { type CellContext } from "@tanstack/react-table";

import { getMetricComparison } from "../utils";

import { Tooltip } from "./tooltip";

interface TableCellProps<TData> {
  cell: CellContext<TData, unknown>;
  metric: SalesMetricV2;
  value?: string | number;
  tableState: TableState;
  rowItemName: string;
  tooltipMetrics: {
    metricBlended: SalesMetricV2;
    metricFt: SalesMetricV2;
    metricRtn: SalesMetricV2;
  };
}

export const CellRevenueFormatter = <TData extends SalesMetricRow>({
  cell,
  metric,
  value,
  tableState,
  rowItemName,
  tooltipMetrics,
}: TableCellProps<TData>) => {
  const rowData = cell.row.original as SalesMetricRow;
  const { metrics, comparisonMetrics } = rowData;

  return (
    <Tooltip
      row={cell.row.original}
      tableState={tableState}
      rowItemName={rowItemName}
      metric={metric}
      tooltipMetrics={tooltipMetrics}
    >
      <div
        className={clsx(
          "border-r-1 border-x-v2-tertiary px-4 py-2.5 bg-inherit text-v2-primary",
          "flex justify-end items-center h-full font-mono text-xs",
        )}
      >
        <div
          className={clsx("flex justify-end gap-1", {
            "flex-col items-end": tableState.showPercentChange,
            "items-center": !tableState.showPercentChange,
          })}
        >
          {value ?? String(cell.getValue())}
          {getMetricComparison(
            metric,
            metrics,
            comparisonMetrics,
            tableState.showPercentChange,
          )}
        </div>
      </div>
    </Tooltip>
  );
};
